import { render, staticRenderFns } from "./openstreetmap.vue?vue&type=template&id=ddf9cafe&"
import script from "./openstreetmap.vue?vue&type=script&lang=js&"
export * from "./openstreetmap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ddf9cafe')) {
      api.createRecord('ddf9cafe', component.options)
    } else {
      api.reload('ddf9cafe', component.options)
    }
    module.hot.accept("./openstreetmap.vue?vue&type=template&id=ddf9cafe&", function () {
      api.rerender('ddf9cafe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2UwmGIk7Rz01W/JS/comp/openstreetmap.vue"
export default component.exports